module.exports = __webpack_public_path__ + "resource/img/admin.d18e4d3e.svg";